import { createSlice } from "@reduxjs/toolkit";

export const icabsProductCoverListSlice = createSlice({
  name: "icabsProductCoverListSlice",
  initialState: {
    icabsProductCoverList: [],
  },
  reducers: {
    setIcabsProductCoverList: (currentSlice, action) => {
      currentSlice.icabsProductCoverList = action.payload;
    },
  },
});

export const { setIcabsProductCoverList } = icabsProductCoverListSlice.actions;
export const icabsProductCoverListReducer = icabsProductCoverListSlice.reducer;
